import { useEffect } from 'react';
import { Layout, Menu, theme, Button } from 'antd';
import {
    UserOutlined,
    PlusCircleOutlined,
} from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import '../../App.css';
import HeaderPrincipal from '../../components/HeaderPrincipal';
import { BreadCrumbs } from '../../components/BreadCrumb';
import { useLoading } from '../../contexts/LoadingContext';
import PagesRoutes from '../../routes/PagesRoutes';
import MenuItems, { itemsProps } from '../../menu';
import { getUsuarioById } from '../../api/usuarios';
import { useAuth } from '../../contexts/AuthContext';
const { Header, Content, Sider } = Layout;


export default function Inicio() {
    const { user, setUser, collapsed, setCollapsed } = useAuth();
    const { setLoading } = useLoading();

    const {
        token: { colorBgContainer },
    } = theme.useToken();
    const selectedKey = useLocation().pathname
    let navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const token = localStorage.getItem('token');

        if (!token
            // || isTokenExpired(expiration)
        ) {
            navigate('/login');
        }
        const idUser = localStorage.getItem('idUser');

        getUsuarioById(idUser).then((response) => {
            setUser(response.data[0])
            setLoading(false);
        });
    }, []);

    const showOnlyMenusWithPermission = (items: itemsProps[], allowedPermissions: string[]) => {
        const itemsWithPermission = items.filter((item) => {
            if (item.permission) {
                const hasPermission = item.permission.some((perm) => allowedPermissions?.includes(perm));
                return hasPermission;
            }
            return true;
        });
        return itemsWithPermission;
    };

    const permissoesDoUsuarios = user?.Permissoes.map((permissao: any) => permissao.tipoPermissao);
    const itemsMenu = showOnlyMenusWithPermission(MenuItems(), permissoesDoUsuarios);

    return (
        <>
            <HeaderPrincipal />
            <Layout style={{ minHeight: '100vh' }}>
                <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} width={230} >
                    <div className={
                        collapsed ? "demo-logo-vertical-collapsed" : "demo-logo-vertical"
                    }>
                        <UserOutlined /> <p>{`${user && user.nome}`}</p>
                    </div>
                    <Menu theme="light" defaultSelectedKeys={['1']} mode="inline" items={itemsMenu} />
                </Sider>
                <Layout>
                    <Header className='pages-header' style={{ background: colorBgContainer }}>
                        <div className='btns-header-bar'>
                            <BreadCrumbs />
                            {(selectedKey.indexOf('/geral/cliente') === -1) && (selectedKey.indexOf('/geral/new') === -1) ? (
                                <Button
                                    type="primary"
                                    icon={<PlusCircleOutlined />}
                                    onClick={() => {
                                        if (selectedKey === '/') {
                                            navigate('/demandas/geral/new')
                                        } else {
                                            // navigate(`${selectedKey}/new`)
                                            navigate('/demandas/geral/new')
                                        }
                                    }
                                    }
                                >
                                    NOVO
                                </Button>
                            ) : null}
                        </div>
                    </Header>
                    <Content style={{ margin: '10px 10px' }}>

                        <PagesRoutes></PagesRoutes>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
